import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function leadBreakupCountDetailsDataReducer(state = initialState.leadBreakupCountDetailsData, action) {
  switch (action.type) {
    case types.LOAD_LEADBREAKUP_DETAILS_DATA_SUCCESS:
      return action.leadBreakupCountDetailsData;
    default:
      return state;
  }
}
